import axios from "axios";
import authChoice from "../../auth";
import environment from "../../env";
import { analyticsApiWrapperGenerator } from "./lib";

function getBaseUrl() {
  return environment.backendType === "firebase"
    ? environment.service[environment.env].analytics
    : environment.service[environment.env]["china"].analytics;
}

const analyticsServer = axios.create({
  baseURL: getBaseUrl(),
});

analyticsServer.interceptors.request.use(
  async (config) => {
    config.headers["x-user-token"] = await authChoice().currentUser.getIdToken();
    return config;
  },
  (error) => Promise.resolve(error)
);

const apiWrapper = analyticsApiWrapperGenerator(analyticsServer);

export const fetchWorkspaceStates = ({ page = 1, size = 500, workspaces }) =>
  apiWrapper("post", `workspaces/list?page=${page}&size=${size}`, { workspaces });

export const getMetabaseUrl = (params) => apiWrapper("post", "metabase/embedded-url", params);

export const getSkillPlaylistProgress = (params) => apiWrapper("post", "skills/assigned", params);

export const getSkillWorkflowProgress = ({ playlistId, ...params }) =>
  apiWrapper("post", `skills/${playlistId}/parts`, params);

export const getManySkillPlaylistProgress = (params) => apiWrapper("post", `skills/users-progress`, params);

export const getGroupUserStats = ({ groupId }) => apiWrapper("post", `workspaces/${groupId}/users`);

export const getOneWorkflowStats = ({ workflowId }) => apiWrapper("post", `workflows/${workflowId}/users`);

export const getOneWorkflowOverview = ({ workflowId }) => apiWrapper("post", `workflows/${workflowId}/overview`);

export const getOneUserOverview = ({ uid }) => apiWrapper("post", `users/${uid}/overview`);

export const getTopGroups = () => apiWrapper("post", "workspaces/top");

export const getOrgOverview = () => apiWrapper("post", "organizations/overview");

export const getOrgEngagement = () => apiWrapper("post", "organizations/engagement");

export const getUserOverview = (params) => apiWrapper("post", "users/overview", params);

export const getUserStats = ({ page = 1, size = 500, users }) =>
  apiWrapper("post", `users/list?page=${page}&size=${size}`, { users });

export const getUserList = ({ apiQueryPage, ...params }) =>
  apiWrapper("post", `users/list?page=${apiQueryPage}&size=100`, params);

export const getTopUsers = () => apiWrapper("post", "users/top");

export const getWorkflowOverview = (params) => apiWrapper("post", "workflows/overview", params);

export const getWorkflowStats = ({ page = 1, size = 500, workflows }) =>
  apiWrapper("post", `workflows/list?page=${page}&size=${size}`, { workflows });

export default analyticsServer;
